import { render } from "./app-card-box.vue?vue&type=template&id=2b8e8a8c"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/card/app-card-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b8e8a8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b8e8a8c', __exports__)) {
    console.log('reload')
    api.reload('2b8e8a8c', __exports__)
  }
  
  module.hot.accept("./app-card-box.vue?vue&type=template&id=2b8e8a8c", () => {
    console.log('re-render')
    api.rerender('2b8e8a8c', render)
  })

}


export default __exports__